import { Controller } from "@hotwired/stimulus"
import { renderAgeStamp } from "../lib/age"

// A server-rendered age stamp (age_stamp helper) that stays true without a
// reload: the sections it sits in are cached and broadcast, so the server's
// "2h" goes stale. Recounted on connect and every minute; a closed stamp
// counts from when the work closed.
export default class extends Controller {
  static values = { created: String, updated: String, closedAt: String, closed: Boolean }

  connect() {
    this.render()
    this.timer = setInterval(() => this.render(), 60_000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  render() {
    renderAgeStamp(this.element, {
      createdAt: this.createdValue,
      updatedAt: this.updatedValue,
      closedAt: this.closedAtValue,
      closed: this.closedValue,
      sinceClosed: true,
    })
  }
}
